import { CopyOutlined } from "@ant-design/icons";
import { Input, Modal } from "antd";
import PropTypes from "prop-types";

import { useAlertStore } from "../../store/alert-store";

function ShareProjectModal({ open, setOpen }) {
  const { setAlertDetails } = useAlertStore();

  // Function to copy text to clipboard
  const copyText = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setAlertDetails({
          type: "success",
          content: "Copied to clipboard",
        });
      })
      .catch((error) => {
        setAlertDetails({
          type: "error",
          content: "Copy failed",
        });
      });
  };

  return (
    <Modal
      open={open}
      title="Share Project"
      onCancel={() => setOpen(false)}
      centered
      footer={null}
      maskClosable={false}
    >
      <div className="sps-share-project-layout">
        <Input
          value={window.location.href}
          suffix={
            <CopyOutlined onClick={() => copyText(window.location.href)} />
          }
        />
      </div>
    </Modal>
  );
}

ShareProjectModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export { ShareProjectModal };
